import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import PropTypes from "prop-types";

import VideoModal from "./VideoModal";
import { useUserController } from "../../context/user";
import { useMaterialUIController } from "../../context";
import colors from "../../colors"
import {useNavigate} from "react-router-dom";

const VideoCard = ({ data: initialData, num }) => {
  const [controller] = useMaterialUIController();
  const { spanish } = controller;

  const [userController] = useUserController();
  const { user } = userController;

  const [data, setData] = useState(initialData);
  const [results, setResults] = useState(null);
  const [rewatch, setRewatch] = useState(false);

  const userVideoData = user?.vData ?? null;
  const navigate = useNavigate();

  useEffect(() => {
    const result = {
      p: !!initialData.passed,
      s: initialData.score > 69 ? initialData.score : undefined,
      t: initialData.taken,
    };

    setData(initialData);
    setResults(result);
  }, [initialData]);

  useEffect(() => {
    if (userVideoData?.id === initialData.id) {
      setRewatch(true);
    }
  }, [userVideoData, initialData.id]);

  const renderResultAction = () => {
    if (!results?.s) return spanish ? "No empezado" : "Not started";

    return (
      <>
        {results.s}%&nbsp;
        {results.s >= 70 ? (
          <CheckCircleRoundedIcon className="progress-icon" color="success" />
        ) : (
          <ErrorRoundedIcon className="progress-icon" color="warning" />
        )}
      </>
    );
  };

  const title = spanish && data.spanish?.title ? data.spanish.title : data.english.title;
  const thumbnail = spanish && data.spanish?.thumb ? data.spanish.thumb : data.english.thumb;

  const goToVideo = (e) => {
    // console.log("goToVideo", e, data, results, rewatch);
    navigate(`/video/${data.id}`)
  }

  return (
    <Grid item key={num}>
      <Card sx={{ maxWidth: 345, borderRadius: 0 }}>
        <CardActionArea onClick={goToVideo}>
          <CardMedia sx={{ height: 250 }} image={thumbnail} />
          <CardContent>
            <Typography variant="h5" component="div">
              {title}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions sx={{backgroundColor: colors.Theme.lightGray}}>
          <Button size="small" color="primary">
            {results && <VideoModal data={data} rewatch={rewatch} results={results} goToVideo={goToVideo}/>}
          </Button>
          <Button size="small" color="primary">
            {results && renderResultAction()}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};

VideoCard.propTypes = {
  data: PropTypes.object.isRequired,
  num: PropTypes.number,
};

export default VideoCard;
